import { CloudObject, Predicate, Query, registerBrick } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import { FiltersAutocomplete } from '../shared/FiltersAutocomplete.jsx';
import { formatFilterOptionsForAPI } from '../shared/_filters';
import { GetLookupDataRc } from './RiskCrisis';
import DropdownConfig from '../shared/filters/DropdownConfig';

export default class RCFiltersAutocomplete extends ReactBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @return {Element}
     */

    static getReactComponent($) {

        return (props) => {
            const entity = useProperty($, 'Entity');
            const selectedFilters = useProperty($, 'Selected Filters') || {};
            const topFilters = useProperty($, 'Top Filters') || '{}';
            /** @type {DropdownConfig}*/
            const dropdownOptionsType = useProperty($, 'Dropdown Config');
            //Add limitcheck property to set a input text value 
            const limitCheck = useProperty($, 'Limit Check');


            let dropdownOptions = [];

            if (dropdownOptionsType?.followSingle(CloudObject.extendRel).executeFromCache().getTag()
                === DropdownConfig.asInstance().getTag()) {
                const jsonString = Query
                    .instancesOf(dropdownOptionsType)
                    .executeFromCache().toArray()
                    .filter(cObject => JSON.parse((/**@type {string}*/ cObject.get(DropdownConfig.jsonProp))).entity === entity)
                [0].get(DropdownConfig.jsonProp);
                const dropdownConfig = JSON.parse(jsonString);
                dropdownOptions = dropdownConfig ? dropdownConfig.options : [];
            }
            // get the selected values for that filter entity
            const selectionForEntity = selectedFilters[entity] || {};
            const selectedOptions = selectionForEntity.values || [];
            const showSelectAll = selectionForEntity.selectedAll || false;

            const componentId = `RCFiltersAutocomplete_${entity}`;

            const updateHeight = () => {
                const element = document.getElementById(componentId);
                if (element && element.parentElement) {
                    $.set('Height', Math.max(element.parentElement.clientHeight, 70));
                }
            };
            let fetchOptions;
            if (dropdownOptions?.length > 0) {
                fetchOptions = () => {
                    return Promise.resolve(dropdownOptions)
                }
            } else {

                fetchOptions = async (searchValue) => {


                    const formattedFilters = {};
                    for (const filterKey in selectedFilters) {
                        formattedFilters[filterKey] = formatFilterOptionsForAPI(filterKey, selectedFilters[filterKey].values);
                    }
                    const response = await GetLookupDataRc(
                        searchValue,
                        entity,
                        formattedFilters,
                        JSON.parse(topFilters),
                    );
                    return response.slice(0, 100000);
                };
            }

            const onChangeHandler = (newSelection, selectedAll) => {

                const updatedFilters = {
                    ...selectedFilters,
                    [entity]: {
                        values: newSelection,
                        selectedAll: selectedAll,
                    },
                };

                const onChangeBrick = $.get('On Change');

                const [triggerInput, updatedFiltersInput] = onChangeBrick.getInputs();
                const [endOutput] = onChangeBrick.getOutputs();
                const onChangeBrick$ = $.runner(onChangeBrick)
                    .set(updatedFiltersInput, updatedFilters)
                    .trigger(triggerInput);
                onChangeBrick$.waitFor(endOutput).then(() => { onChangeBrick$.destroy(); });
            };

            return <FiltersAutocomplete
                id={componentId}
                disabled={false}
                fetchOptions={fetchOptions}
                getOptionLabel={RCFiltersAutocomplete.getOptionLabel}
                selectedOptions={selectedOptions}
                showSelectAll={showSelectAll}
                onChange={onChangeHandler}
                updateHeight={updateHeight}
                limitCheck={limitCheck}
            />;
        };
    }
}

/**
 * @param {FiltersAutocompleteOption} option
 * @return {string}
 */
RCFiltersAutocomplete.getOptionLabel = (option) => {

    if (typeof option.id === 'string' && option.id !== '') {

        return (parseInt(option.id) && option.id.length > 4) ? // made for removing leading 0000 (I suppose). Testing for length > 4 seems to exclude plant ids
            `${parseInt(option.id)} - ${option.description}` :
            `${option.id}` + ((option.description && option.description !== 'null') ? `- ${option.description}` : '');
    } else return `${option.description}`;
};

registerBrick('018806927450e2c7af7e', RCFiltersAutocomplete);
